






















import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'

@Component
export default class Range extends Vue {
    @PropSync('min', {default: ''}) minVal!: any

    @PropSync('max', {default: ''}) maxVal!: any

    @Prop({default: false}) isInt!: any

    @Prop({default: false}) disabled!: any
}
